import PropTypes from 'prop-types';
import { trackEvent } from 'dibs-tracking';
import slugify from 'dibs-slugify/exports/slugify';
import { ALWAYS_LINKABLE_LINK, SeoLink } from 'dibs-seo/src/SeoLink/SeoLink';

import styles from './SiteNav-style.scss';

const trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
};

const SiteNavDropdownColumn = ({ items, trackingLabelPrefix }) => (
    <div className={styles.dropdownCol}>
        {items.map((item, index) => (
            <div key={`${item.name}${index}`} className={styles.dropdownSection}>
                {item.name ? <div className={styles.dropdownHeader}>{item.name}</div> : null}
                {(item.items || []).map(({ name, linkData }, subItemIndex) => {
                    const label = `${trackingLabelPrefix}|${item.name}|${name}`;
                    return (
                        <SeoLink
                            key={`${name}${subItemIndex}`}
                            dataTn={`global-nav-item-link-${slugify(label)}`}
                            className={styles.dropdownLink}
                            onClick={() => {
                                trackEvent(
                                    Object.assign({}, trackingObj, {
                                        label: label.toLowerCase(),
                                    })
                                );
                            }}
                            variant={ALWAYS_LINKABLE_LINK}
                            linkData={linkData}
                        >
                            {name}
                        </SeoLink>
                    );
                })}
            </div>
        ))}
    </div>
);

SiteNavDropdownColumn.propTypes = {
    items: PropTypes.array,
    trackingLabelPrefix: PropTypes.string,
};

export default SiteNavDropdownColumn;
